export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LcrWaUsAAAAAALpnhpzfYdVIUzoPpkmgOZ54sCu',
  },

  baseUrl: 'https://www.email.googleassistantprivacylitigation.com/api/'

};

